import React from "react";

const FabricatedMetalProductsIcon = ({
  color = "#5D5D5D",
  width = "23",
  height = "23",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2985_11350)">
        <path
          d="M13.0611 22.2812H2.15625C1.77501 22.2812 1.40936 22.1298 1.13978 21.8603C0.8702 21.5907 0.71875 21.225 0.71875 20.8437V2.15625C0.71875 1.77501 0.8702 1.40936 1.13978 1.13978C1.40936 0.8702 1.77501 0.71875 2.15625 0.71875H20.8437C21.225 0.71875 21.5907 0.8702 21.8603 1.13978C22.1298 1.40936 22.2812 1.77501 22.2812 2.15625V13.0611C22.2812 13.4421 22.1298 13.8075 21.8605 14.077L14.077 21.8605C13.8075 22.1298 13.4421 22.2812 13.0611 22.2812Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6562 22.1519V15.0937C13.6562 14.7125 13.8077 14.3468 14.0772 14.0772C14.3468 13.8077 14.7125 13.6562 15.0937 13.6562H22.1519"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.46875 6.46875H17.9687"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.46875 10.7812H11.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2985_11350">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FabricatedMetalProductsIcon;
